import React, { useEffect, useState } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Loader from 'react-loader-spinner';

const DealerAssignForm = ({ user, product, login }) => {

    const [dealerId, setDealerId] = useState();
    const [dealers, setDealers] = useState([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        getPossibleDealerships();
    }, [])


    const getPossibleDealerships = async () => {
        setLoading(true);
        const headers = { 'Authorization': user.api_key }
        // const headers = { 'Authorization': 'bf17cb82fc14b118859da45b049fa2e3' }
        const res = await axios.post('https://evalexpert.io/v1/getPossibleDealers', null, { headers: headers })
        const data = res.data;


        if (data.success) {
            setDealers(data.data);
            setLoading(false);
        } else {
            login()
        }

    }

    return (
        <Formik
            initialValues={{
                pin: '',
            }}
            validate={values => {
                const errors = {};
                return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {

                setSubmitting(true);

                const headers = { 'Authorization': user.api_key }
                const res = await axios.post('https://evalexpert.io/v1/addUserToDealer', { dealerId: dealerId, product }, { headers: headers })
                const data = res.data;

                setSubmitting(false);

                if (data.success) {
                    // history.push('/insightsdashboard/pages/dashboard/signin');
                    setLoading(true);
                    login();
                }

            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} className="space-y-6">
                    {loading && <div className="flex  my-12">
                        <Loader
                            className="mx-auto opacity-70"
                            type="Rings"
                            color="#2879BE"
                            height={100}
                            width={100}
                        />
                    </div>}
                    {!loading &&
                        <>
                            <div>
                                <p className="text-gray-700">Are you joining as a member of one of the following dealerships?</p>
                                <div className="mt-1">
                                    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                        <label htmlFor="country" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                                            Dealerships
                                        </label>
                                        <div className="mt-1 sm:mt-0 sm:col-span-2">
                                            <select
                                                id="country"
                                                name="country"
                                                autoComplete="country"
                                                onChange={(event) => setDealerId(event.target.value)}
                                                value={dealerId}
                                                className="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                            >
                                                <option>Select a dealership</option>
                                                {dealers.map((dealer) => <option key={dealer.id} value={dealer.id}>{dealer.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                                    disabled={isSubmitting}
                                >
                                    Confirm
                                </button>

                                <p className="mt-2 text-sm text-gray-700">
                                    Don't regonise any of the dealerships? <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => history.push('/insightsdashboard/pages/dashboard/signin')}>Continue</p>
                                </p>
                            </div>
                        </>
                    }
                </form>
            )}
        </Formik>
    )
}

export default DealerAssignForm;
